var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type==='1')?_c('info',{attrs:{"center-id":_vm.centerId},on:{"typeChange":function($event){_vm.type='2'}}}):_c('center-info',{on:{"change":_vm.centerIdChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }